import { TabPanel } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const StyledTabPanel = styled(TabPanel)`
  padding: 0;
  margin-bottom: 12px;

  [data-tablist] {
    justify-content: flex-start;
    gap: 4px;
  }

  [data-tab-panel-content] {
    height: auto;
    min-height: unset;
  }

  [data-tab-panel-tab] {
    padding: 6px 16px;
  }

  [data-tab-panel-tab][aria-selected='true'] {
    border-width: 1px 1px 0px 1px;
    border-style: solid;
    border-color: var(--border-soft);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }
`;

export const Placeholder = styled.div`
  padding: 8px 0;
  color: var(--text-secondary);
`;

export const TabsContentWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0px 20px;
  width: 100%;
  flex: 1 1 0px;
  min-height: 0;
`;
